import { useState, useEffect } from 'react';
import { authAPI } from '../services/api';
import GuestSetup from './GuestSetup';
import SetupPage from './SetupPage';
import DemoUnderConstruction from './DemoUnderConstruction';
import MemberLoginModal from '../components/MemberLoginModal';

export default function PortalSetup() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isDemo, setIsDemo] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [language] = useState<'ja' | 'en'>('ja');

  useEffect(() => {
    checkAuth();
  }, []);

  async function checkAuth() {
    try {
      const result = await authAPI.checkMemberAuth();
      setIsAuthenticated(result.authenticated);
      setIsDemo(result.isDemo || false);
    } catch (error) {
      setIsAuthenticated(false);
      setIsDemo(false);
    }
  }

  function handleMemberLogin() {
    setShowLoginModal(true);
  }

  async function handleLoginSuccess() {
    setShowLoginModal(false);
    await checkAuth(); // Re-check to get demo status
  }

  function handleBack() {
    // Logout and return to guest page
    authAPI.memberLogout().finally(() => {
      setIsAuthenticated(false);
      setIsDemo(false);
    });
  }

  // Loading state
  if (isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">{language === 'ja' ? '読み込み中...' : 'Loading...'}</p>
        </div>
      </div>
    );
  }

  // Show demo page if demo user
  if (isAuthenticated && isDemo) {
    return <DemoUnderConstruction language={language} onBack={handleBack} />;
  }

  // Show member setup page if authenticated (real member)
  if (isAuthenticated) {
    return <SetupPage />;
  }

  // Show guest setup (user manual) if not authenticated
  return (
    <>
      <GuestSetup onMemberLogin={handleMemberLogin} />
      <MemberLoginModal
        isOpen={showLoginModal}
        onClose={() => setShowLoginModal(false)}
        onSuccess={handleLoginSuccess}
        language={language}
      />
    </>
  );
}
